var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indicator-class"},[_c('SimpleTable',{ref:"IndicatorClass",attrs:{"show-index":false,"table-code":"IndicatorClass","columns":_vm.columns,"data":_vm.tableData,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }